<div class="onboarding-page">
  <div class="page-header text-center">
    <span class="logo logo-white"></span>
  </div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-4">
        <div class="card shadow-3 rd-3">
          <app-loader *ngIf="loading"></app-loader>


          <div class="card-body">

            <div class="mt-3">
              <app-alert [msg]="errorMsg" type="danger"></app-alert>
            </div>

          </div>
        </div>

      </div>

    </div>
  </div>

</div>
